<template>
	<div class="visually-hidden">
		<h1 class="H1title" id="H1title">
			{{ titleName }}
		</h1>
	</div>
</template>

<script>

export default {
	name: 'Htitle',

	// props: {
	// 	Loading: {
	// 		type: Boolean,
	// 		default: false,
	// 	},
	// 	calling_modules: {
	// 		type: String,
	// 		default: ""
	// 	},
	// },
	data() {
		return {
			titleName: "",
		}
	},
	
	// 监听
	watch: {
		'$route': {
		   handler (newValue, oldValue) {
				this.set_title_name()
		   },
		   deep: true
		}
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  
	},
  
	mounted() {
		this.set_title_name()
	},
  
	methods:{
		//去登录
		set_title_name(){
			console.log(this.$router.options.routes)
			let routes = this.$router.options.routes
			let currentRouteName = this.$router.currentRoute.name
			
			// post_content
			
			const routeItem = routes.find(
			   r => r.name === this.$router.currentRoute.name
			);
			console.log(currentRouteName)
			
			let titleName = ""
			if(routeItem){
				if(currentRouteName.includes('post-details')){
					let post_content = this.$route.params.post_content
					titleName = post_content ? post_content : routeItem.title
				}else if(currentRouteName == 'users'){
					let nickname = this.$route.params.nickname
					titleName = nickname ? nickname : routeItem.title
				}else{
					titleName = routeItem.title
				}
			}
			
			this.$setTags.updateTitle(titleName)
			this.titleName = titleName ? titleName : "TOZO Community Home";
			// this.titleName = routeItem ? routeItem.title : "TOZO Community Home";
		},
	}
}
</script>

<style lang="less" scoped>
	.visually-hidden{
		display: none;
		.H1title{
			font-size: 24px;
			color: #333333;
		}
	}
</style>
